import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-y-4 p-4 sm:p-6 lg:p-8" }
const _hoisted_2 = { class: "flex items-center text-xl font-semibold text-gray-800" }
const _hoisted_3 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_4 = {
  key: 0,
  class: "space-y-2"
}

import { ref, computed, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { AxiosResponse } from 'axios';

import { useUiStore } from '@/stores';
import ConnectFlowService from '@/services/api/ConnectFlowService';
import { toastServiceError } from '@/services/core/notification';

import { ConnectFlowModel, ConnectFlowFlowModel } from '@/types';

import { ConnectFlowHistoryItem } from '@/views/pages/connect-flow/components';
import ConnectFlowIcon from '@/components/svg/ConnectFlowIcon';

const perPage = 10;


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectFlowHistoryPage',
  setup(__props) {

const route = useRoute();
const uiStore = useUiStore();

const connectFlow = ref<ConnectFlowModel | undefined>(undefined);
const currentPage = ref(1);
const flows = computed<ConnectFlowFlowModel[]>(() => {
    return (connectFlow.value?.flows || []).slice().sort((a, b) => {
        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
    });
});

const count = computed<number>(() => flows.value.length);

const paginatedFlows = computed<ConnectFlowFlowModel[]>(() => {
    const start = (currentPage.value - 1) * perPage;
    return flows.value.slice(start, start + perPage);
});

const setLoading = (loading: boolean) => uiStore.setIsLoading(loading);

const fetchConnectFlow = async (id: number) => {
    await setLoading(true);
    try {
        const response: AxiosResponse<ConnectFlowModel> =
            await ConnectFlowService.get<ConnectFlowModel>(id);
        connectFlow.value = response.data;
    } catch (error) {
        toastServiceError(error);
    } finally {
        await setLoading(false);
    }
};

watch(flows, () => {
    currentPage.value = 1;
});

onMounted(() => {
    const id = Number(route.params.id);
    fetchConnectFlow(id);
});

return (_ctx: any,_cache: any) => {
  const _component_UiBackButton = _resolveComponent("UiBackButton")!
  const _component_UiPageHeader = _resolveComponent("UiPageHeader")!
  const _component_UiPanel = _resolveComponent("UiPanel")!
  const _component_UiPagination = _resolveComponent("UiPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiPageHeader, null, {
      info: _withCtx(() => [
        _createElementVNode("h1", _hoisted_2, [
          _createVNode(_unref(ConnectFlowIcon), {
            class: "mr-1 h-6 w-6 text-gray-500",
            "aria-hidden": "true"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('connectFlow.history.title')), 1)
        ])
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_UiBackButton, { fallbackTo: { name: 'ListConnectFlow' } })
      ]),
      _: 1
    }),
    (connectFlow.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (paginatedFlows.value?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedFlows.value, (flow) => {
                  return (_openBlock(), _createBlock(_unref(ConnectFlowHistoryItem), {
                    key: flow.id,
                    "model-value": flow,
                    published: flow.id === connectFlow.value?.lastAppliedFlowId
                  }, null, 8, ["model-value", "published"]))
                }), 128))
              ]))
            : (_openBlock(), _createBlock(_component_UiPanel, {
                key: 1,
                class: "flex items-center justify-center"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('core.messages.noRecordsFound')), 1)
                ]),
                _: 1
              })),
          (flows.value?.length)
            ? (_openBlock(), _createBlock(_component_UiPagination, {
                key: 2,
                modelValue: currentPage.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
                count: count.value,
                perPage: perPage
              }, null, 8, ["modelValue", "count"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})